import { GoogleOAuthProvider } from '@react-oauth/google';
import { createAuthProvider } from './context';
import { webStorage } from './storage';

// Create the base auth provider
const BaseAuthProvider = createAuthProvider({
  apiBaseUrl: import.meta.env.VITE_API_URL || 'http://localhost:5009',
  storage: webStorage,
});

// Wrap the base provider with web-specific OAuth providers
export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ''}>
      <BaseAuthProvider>
        {children}
      </BaseAuthProvider>
    </GoogleOAuthProvider>
  );
}

// Re-export the useAuth hook
export { useAuth } from './context';

// Re-export OAuth functions
export { loginWithGoogle, loginWithMicrosoft, handleGoogleCallback, handleMicrosoftCallback } from './oauth';

// Re-export logout utility
export { performLogout, type LogoutOptions } from './logout'; 